// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.btn{\r\n  margin: 5px;\n}\n.table-body-cell-class1 {\r\n  background: #91d5ff !important;\r\n  color: #fff !important;\n}\n.table-body-cell-class2 {\r\n  background: orange !important;\r\n  color: #fff !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
